import "core-js/modules/es7.object.get-own-property-descriptors";
import "core-js/modules/web.dom.iterable";
import "core-js/modules/es6.object.keys";
import _toConsumableArray from "/var/lib/jenkins/workspace/yesep-ui/node_modules/@babel/runtime-corejs2/helpers/esm/toConsumableArray.js";
import _defineProperty from "/var/lib/jenkins/workspace/yesep-ui/node_modules/@babel/runtime-corejs2/helpers/esm/defineProperty.js";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import PageLayout from '@/components/page/PageLayout';
import RouteView from "@/components/layouts/RouteView";
import { AppPage, ArticlePage, ProjectPage } from "./page";
import { mapGetters } from 'vuex';
export default {
  components: {
    RouteView: RouteView,
    PageLayout: PageLayout,
    AppPage: AppPage,
    ArticlePage: ArticlePage,
    ProjectPage: ProjectPage
  },
  data: function data() {
    return {
      tags: ['很有想法的', '专注设计', '辣~', '大长腿', '川妹子', '海纳百川'],
      tagInputVisible: false,
      tagInputValue: '',
      teams: [],
      teamSpinning: true,
      tabListNoTitle: [{
        key: 'article',
        tab: '文章(8)'
      }, {
        key: 'app',
        tab: '应用(8)'
      }, {
        key: 'project',
        tab: '项目(8)'
      }],
      noTitleKey: 'app'
    };
  },
  mounted: function mounted() {
    this.getTeams();
  },
  methods: _objectSpread(_objectSpread({}, mapGetters(["nickname", "avatar"])), {}, {
    getAvatar: function getAvatar() {
      return window._CONFIG['imgDomainURL'] + "/" + this.avatar();
    },
    getTeams: function getTeams() {
      var _this = this;

      this.$http.get('/api/workplace/teams').then(function (res) {
        _this.teams = res.result;
        _this.teamSpinning = false;
      });
    },
    handleTabChange: function handleTabChange(key, type) {
      this[type] = key;
    },
    handleTagClose: function handleTagClose(removeTag) {
      var tags = this.tags.filter(function (tag) {
        return tag != removeTag;
      });
      this.tags = tags;
    },
    showTagInput: function showTagInput() {
      var _this2 = this;

      this.tagInputVisible = true;
      this.$nextTick(function () {
        _this2.$refs.tagInput.focus();
      });
    },
    handleInputChange: function handleInputChange(e) {
      this.tagInputValue = e.target.value;
    },
    handleTagInputConfirm: function handleTagInputConfirm() {
      var inputValue = this.tagInputValue;
      var tags = this.tags;

      if (inputValue && tags.indexOf(inputValue) === -1) {
        tags = [].concat(_toConsumableArray(tags), [inputValue]);
      }

      Object.assign(this, {
        tags: tags,
        tagInputVisible: false,
        tagInputValue: ''
      });
    }
  })
};